import type { PlanMail } from "./mail-rewards";

// Where a membership's monthly mail ships, in words (see mail-rewards.ts), with no schema
// library, so a creator site's script stays small.

let regionNames: Intl.DisplayNames | undefined;

/** "United States" for US. A code without a name still reads as itself. */
export function countryLabel(code: string) {
  try {
    regionNames ??= new Intl.DisplayNames(["en"], { type: "region" });
    return regionNames.of(code) ?? code;
  } catch {
    return code;
  }
}

/** "ships anywhere", "ships to the United States" or "ships to 4 countries". */
export function shipsToPhrase(countries: PlanMail["countries"]) {
  if (countries === "all") return "ships anywhere";
  if (countries.length > 3) return `ships to ${countries.length} countries`;
  const names = countries.map((code) =>
    ["US", "GB", "NL", "AE", "PH"].includes(code)
      ? `the ${countryLabel(code)}`
      : countryLabel(code),
  );
  return `ships to ${names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names.at(-1)}` : names[0]}`;
}

/** "Ships anywhere" or "Ships to the United States". */
export function shipsToLabel(countries: PlanMail["countries"]) {
  const phrase = shipsToPhrase(countries);
  return phrase[0]!.toUpperCase() + phrase.slice(1);
}

/** Whether a membership's mail can go to an address in this country. */
export function mailShipsTo(mail: PlanMail, country: string) {
  return mail.countries === "all" || mail.countries.includes(country);
}
